import React from 'react';

import { connect } from 'react-redux';
import { fromReservation, fromMarket } from 'store/selectors';

import { PayingCustomer } from 'components';


const PayingCustomerContainer = props => <PayingCustomer {...props} />;
const mapStateToProps = (state) => {
  const payingCustomer = fromReservation.getPayingCustomer(state);
  const titles = fromMarket.getTitles(state);

  const title = payingCustomer.title ? (titles.find(obj => obj.code === payingCustomer.title) || {}).text : '';

  return {
    ...payingCustomer,
    title,
  };
};

export default connect(mapStateToProps)(PayingCustomerContainer);



// WEBPACK FOOTER //
// ./src/containers/PayingCustomer.js